module.exports = __webpack_public_path__ + "img/settlements.fee9cca3.svg";